
      module.exports = {
        functional: true,
        render(_h, _vm) {
          const { _c, _v, data, children = [] } = _vm;

          const {
            class: classNames,
            staticClass,
            style,
            staticStyle,
            attrs = {},
            ...rest
          } = data;

          return _c(
            'svg',
            {
              class: [classNames,staticClass],
              style: [style,staticStyle],
              attrs: Object.assign({"xmlns":"http://www.w3.org/2000/svg","width":"21.883","height":"27.3"}, attrs),
              ...rest,
            },
            children.concat([_c('g',{attrs:{"data-name":"Gruppe 140","fill":"none","stroke":"#fff","stroke-linecap":"round","stroke-linejoin":"round","stroke-width":"1.3"}},[_c('g',{attrs:{"data-name":"Gruppe 138"}},[_c('path',{attrs:{"data-name":"Pfad 106","d":"M15.817.65h-13A2.166 2.166 0 00.65 2.817v21.667a2.166 2.166 0 002.167 2.166h16.25a2.167 2.167 0 002.167-2.167V6.067h-5.417z"}}),_c('path',{attrs:{"data-name":"Pfad 107","d":"M15.817.65v5.417h5.417z"}})]),_c('g',{attrs:{"data-name":"Gruppe 139"}},[_c('path',{attrs:{"data-name":"Pfad 108","d":"M16.9 21.238H4.988a.005.005 0 110-.011h11.917a.005.005 0 010 .011z"}}),_c('path',{attrs:{"data-name":"Pfad 109","d":"M16.9 18.53H4.988a.005.005 0 110-.011h11.917a.005.005 0 010 .011z"}})]),_c('g',{attrs:{"data-name":"<Group>","transform":"translate(6.067 6.067)"}},[_c('circle',{attrs:{"data-name":"Ellipse 24","cx":"2.438","cy":"2.438","r":"2.438","transform":"translate(2.437)"}}),_c('path',{attrs:{"data-name":"Pfad 110","d":"M9.75 8.663v-.867a2.445 2.445 0 00-2.437-2.437H2.438A2.445 2.445 0 000 7.8v.867z"}})])])])
          )
        }
      }
    